import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import firebaseService from '../services/firebaseService';
import Navigation from './Navigation';

function FormList() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadForms();
  }, []);

  const loadForms = async () => {
    try {
      setLoading(true);
      setError('');
      const formsList = await firebaseService.getForms();
      setForms(formsList);
    } catch (err) {
      setError('Failed to load forms. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFormClick = (formId) => {
    navigate(`/form/${formId}`);
  };

  return (
    <div className="form-list-container">
      <Navigation />
      
      <div className="content-wrapper">

      {loading && (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading forms...</p>
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
          <button onClick={loadForms} className="btn-retry">
            Retry
          </button>
        </div>
      )}

      {!loading && !error && forms.length === 0 && (
        <div className="no-forms">
          <p>No forms available at the moment.</p>
        </div>
      )}

      {!loading && !error && forms.length > 0 && (
        <div className="forms-grid">
          {forms.map((form) => (
            <div 
              key={form.id} 
              className="form-card"
              onClick={() => handleFormClick(form.id)}
            >
              <h3>{form.name || form.title || 'Untitled Form'}</h3>
              {form.description && (
                <p className="form-description">{form.description}</p>
              )}
              <div className="form-meta">
                {form.category && (
                  <span className="badge">{form.category}</span>
                )}
                {form.url && (
                  <span className="url-indicator" title={form.url}>
                    🔗 Remote Form
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}

export default FormList;
